// Material
import { styled } from '@mui/material/styles'
import {
  Divider,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Skeleton,
} from '@mui/material'

const StyledListItemButton = styled(ListItemButton)`
  height: 56px;
  text-align: inherit;
  box-sizing: border-box;
  padding: 0 16px;
`

const StyledListItem = styled(ListItem)`
  text-align: inherit;
  padding: 0;
  .MuiTouchRipple-child {
    background-color: #f9f9f9;
  }
`

const StyledListItemIcon = styled(ListItemIcon)`
  min-width: 24px;
  margin-left: 12px;
  color: ${({ theme }) => theme.palette.primary500};
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    width: 24px;
    height: 24px;
  }
  &.with-background {
    min-width: 32px;
    height: 32px;
    border-radius: 12px;
    svg {
      width: 20px;
      height: 20px;
    }
  }
  background-color: ${props =>
    props.theme.palette[props['data-bg-color'] as string] || 'transparent'};
`

const StyledSecondaryListItemText = styled(ListItemText)(({ theme }) => ({
  flex: 'none',
}))

const StyledDivider = styled(Divider)`
  &:last-child {
    display: none;
  }
`

interface Props {
  Icon: JSX.Element
  onClick: () => any
  children: JSX.Element | string
  secondaryText?: number | string
  secondaryTextLoading?: boolean
  disabled?: boolean
  iconVariant?: 'with-background' | 'default'
  iconBgColor?: string
}

export function ProfileActionItem({
  Icon,
  onClick,
  children,
  secondaryText,
  secondaryTextLoading,
  disabled,
  iconVariant = 'default',
  iconBgColor,
}: Props) {
  return (
    <>
      <StyledListItem onClick={onClick}>
        <StyledListItemButton disableGutters disabled={disabled}>
          <StyledListItemIcon
            data-bg-color={iconBgColor}
            className={iconVariant}
          >
            {Icon}
          </StyledListItemIcon>
          <ListItemText primaryTypographyProps={{ variant: 'body1' }}>
            {children}
          </ListItemText>

          {secondaryTextLoading ? (
            <Skeleton sx={{ minWidth: '25px' }} />
          ) : secondaryText ? (
            <StyledSecondaryListItemText
              primaryTypographyProps={{
                variant: 'subtitle3',
                color: 'secondary.main',
              }}
            >
              {secondaryText}
            </StyledSecondaryListItemText>
          ) : null}
        </StyledListItemButton>
      </StyledListItem>

      <StyledDivider />
    </>
  )
}

ProfileActionItem.defaultProps = {
  secondaryText: null,
  secondaryTextLoading: false,
  disabled: false,
}
